/**
 * Rocksoft.Sync.OsUpdates
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const OsUpdateStatusState = {
    None: 'None',
    Idle: 'Idle',
    CheckedIn: 'CheckedIn',
    Installing: 'Installing',
    DownloadCompleted: 'DownloadCompleted',
    Downloading: 'Downloading',
    LowBatteryLevel: 'LowBatteryLevel',
    Failed: 'Failed',
} as const;
export type OsUpdateStatusState = typeof OsUpdateStatusState[keyof typeof OsUpdateStatusState];

